export default __webpack_public_path__ + "static/media/no-image-available.d09e5038.png";